import React, { useState } from 'react';
import { Button, Tooltip } from '@wfp/ui';
import { Link } from 'react-router-dom';
import { iconChevronLeft, iconChevronRight } from '@wfp/icons';
import { Col, Row } from 'react-flexbox-grid';

import { addMonths, joinSimpleDate, previousDay, type SimpleDate, splitSimpleDate } from '../../utils/SimpleDate';
import { formatDateShort } from '../../utils/utils';

import "./PeriodPicker.scss";


interface Props {
	selectedDate: SimpleDate;
}

const startMonths = [1, 4, 7, 10];

export function PeriodPicker({selectedDate, children}: React.PropsWithChildren<Props>) {
	const [y] = splitSimpleDate(selectedDate);
	const [year, setYear] = useState(y);

	return (
		<Tooltip trigger="click" placement="right-start"
				 createRefWrapper={true}
				 content={<div className="period-picker">
					 <Row middle="xs" className="period-header">
						 <Col xs>
							 <Button icon={iconChevronLeft} kind="ghost"
									 onClick={() => setYear(year - 1)}
							 />
						 </Col>
						 <Col xs>
							 <h4>{year}</h4>
						 </Col>
						 <Col xs>
							 <Button icon={iconChevronRight} kind="ghost"
									 onClick={() => setYear(year + 1)}
							 />
						 </Col>
						 <Col xs>
							 <Link to="/">
								 <Button kind="ghost" small>Today</Button>
							 </Link>
						 </Col>
					 </Row>
					 {startMonths.map(m => {
						 const from = joinSimpleDate(year, m, 1);
						 const to = previousDay(addMonths(from, 6));
						 const kind = (from === selectedDate) ? 'primary' : 'ghost'
						 return <Link key={from} to={`/${from}`}>
							 <Button kind={kind}>{formatDateShort(from)} &mdash; {formatDateShort(to)}</Button>
						 </Link>;
					 })}
				 </div>}>
			{children}
		</Tooltip>
	);
}